module.exports = __webpack_public_path__ + "static/media/pharmacy-group78.4c22935b.webp";